import {Component, Input} from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-screen-size-alert',
  templateUrl: './screen-size-alert.component.html',
  styleUrls: ['./screen-size-alert.component.css']
})
export class ScreenSizeAlertComponent {
  @Input() hyperLinkText: string = ''
  @Input() navigationLink: string = ''

  constructor(private router: Router) {
  }

  backToResourceList() {
    this.router.navigate([this.navigationLink])
  }
}
